import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import AdminSettingsSponsors from "./AdminSettingsSponsors";
import AdminSettingsRewards from "./AdminSettingsRewards";
import LoaderBox from "../HomePage/LoaderBox";
import AdminSettingsParty from "./AdminSettingsParty";
import AdminBelaTurnir from "./AdminBelaTurnir";
import AdminSettingsCountDown from "./AdminSettingsCountDown";
import AdminSettingsStats from "./AdminSettingsStats";
import AdminSettingsPassword from "./AdminSettingsPassword";
import AdminNogotenisTurnir from "./AdminNogotenisTurnir";

const AdminSettings = ({ settingsPage, setSettingsPage, selectedTurnirId }) => {
  const [loading, setLoading] = useState(true);
  const [turnirData, setTurnirData] = useState(null);

  // Dohvaćamo podatke o turniru da vidimo što je uključeno (npr. bela, košarka...)
  useEffect(() => {
    const fetchTurnirConfig = async () => {
      if (!selectedTurnirId) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from("admin_turniri")
          .select("*")
          .eq("id", selectedTurnirId)
          .maybeSingle();

        if (error) throw error;
        setTurnirData(data);
      } catch (err) {
        console.error("Greška pri dohvaćanju postavki turnira:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTurnirConfig();
  }, [selectedTurnirId]);

  // Pod-stranice
  if (settingsPage === "countdown") {
    return (
      <AdminSettingsCountDown
        selectedTurnirId={selectedTurnirId}
        onBack={() => setSettingsPage("menu")}
      />
    );
  }

  if (settingsPage === "belaTurnir") {
    return (
      <AdminBelaTurnir
        turnirId={selectedTurnirId}
        selectedTurnirId={selectedTurnirId}
        onBack={() => setSettingsPage("menu")}
      />
    );
  }
  if (settingsPage === "nogotenisTurnir") {
    return (
      <AdminNogotenisTurnir
        turnirId={selectedTurnirId}
        selectedTurnirId={selectedTurnirId}
        onBack={() => setSettingsPage("menu")}
      />
    );
  }
  if (settingsPage === "sponsors") {
    return (
      <AdminSettingsSponsors
        turnirId={selectedTurnirId}
        onBack={() => setSettingsPage("menu")}
      />
    );
  }
  if (settingsPage === "rewards") {
    return (
      <AdminSettingsRewards
        selectedTurnirId={selectedTurnirId}
        onBack={() => setSettingsPage("menu")}
      />
    );
  }

  if (settingsPage === "party") {
    return (
      <AdminSettingsParty
        selectedTurnirId={selectedTurnirId}
        onBack={() => setSettingsPage("menu")}
      />
    );
  }
  if (settingsPage === "stats") {
    return (
      <AdminSettingsStats
        turnir={turnirData}
        onBack={() => setSettingsPage("menu")}
      />
    );
  }
  if (settingsPage === "password") {
    return <AdminSettingsPassword onBack={() => setSettingsPage("menu")} />;
  }

  // Definiramo sve moguće opcije
  const allOptions = [
    {
      id: "countdown",
      title: 'Uredi "Odbrojavanje"',
      icon: "fi-rs-hourglass-end",
      color: "#5ef1bbff",
      alwaysShow: true,
    },
    {
      id: "belaTurnir",
      title: 'Uredi "Bela turnir"',
      icon: "fi-rs-card-spade",
      color: "#f1cc5eff",
      showCondition:
        turnirData?.features?.beli === true ||
        turnirData?.features?.bela === true ||
        turnirData?.beli === true ||
        turnirData?.bela === true,
    },

    {
      id: "nogotenisTurnir",
      title: 'Uredi "Nogotenis turnir"',
      icon: "fi-rs-football-player",
      color: "#6cd986ff",
      showCondition:
        turnirData?.features?.nogotenis === true ||
        turnirData?.features?.nogotenis === true ||
        turnirData?.nogotenis === true ||
        turnirData?.nogotenis === true,
    },
    {
      id: "rewards",
      title: 'Uredi "Nagradni fond"',
      icon: "fi-rs-trophy",
      color: "#00FF00",
      alwaysShow: true,
    },
    {
      id: "sponsors",
      title: 'Uredi "Sponzore"',
      icon: "fi-rs-handshake",
      color: "#00BFFF",
      alwaysShow: true,
    },

    {
      id: "party",
      title: 'Uredi "Događaje"',
      icon: "fi-rs-party-horn",
      color: "#FF4500",
      alwaysShow: true,
    },
    {
      id: "stats",
      title: "Statistika turnira",
      icon: "fi-rs-chart-simple",
      color: "#ccc12eff",
      alwaysShow: true,
    },
    {
      id: "password",
      title: "Promjena lozinke",
      icon: "fi-rs-lock",
      color: "#ff4d4d",
      alwaysShow: true,
    },
  ];

  const adminOptions = allOptions.filter(
    (opt) => opt.alwaysShow || opt.showCondition,
  );

  if (loading) return <LoaderBox text="Učitavanje..." />;

  return (
    <div className="admin-settings-menu">
      <div className="admin-header">
        <h3>Postavke</h3>
      </div>
      <div className="admin-grid">
        {adminOptions.map((opt) => (
          <div
            key={opt.id}
            className="admin-card"
            onClick={() => setSettingsPage(opt.id)}
          >
            <i className={`fi ${opt.icon}`} style={{ color: opt.color }}></i>
            <span>{opt.title}</span>
            <i className="fi fi-rs-angle-small-right"></i>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminSettings;
